import { apiConstants } from '../../apiConstant'
import { serviceCall } from '../../serviceCall'

const deletePurchaseItem = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    serviceCall({
      url: apiConstants.TICKET.DELETE_PURCHASE_ITEM,
      method: 'delete',
      data: data,
    })
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}

export default deletePurchaseItem